import BaseController from './base.js';

export default class extends BaseController {
}